import React from 'react';

import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
// import GoogleMapReact from 'google-map-react';
// import config from 'utils/config';
// import links from 'utils/links';
import TagNames from './TagNames';
import CityTag from './OtherDishes';

const styles = theme => ({
  insetDarkTop: {
    padding: '20px',
    backgroundColor: '#ebebeb',
  },
  gridAlign: {
    textAlign: 'left',
    fontFamily: 'Catamaran, Roboto, Helvetica, Arial, sans-serif',
  },
  location: {
    marginTop: '7px',
    fontFamily: 'Catamaran, Roboto, Helvetica, Arial, sans-serif',
  },
  insetDarkBottom: {
    backgroundColor: '#f9f9f9',
  },
  semibold: {
    textAlign: 'left',
    padding: '20px',
  },
  tags: {
    marginTop: '7px',
    fontFamily: 'Catamaran, Roboto, Helvetica, Arial, sans-serif',
  },
  icon: {
    fontSize: '3em',
  },
});

class SecondaryStory extends React.Component {
  renderMarkers(map, maps) {
    const { location } = this.props;
    return new maps.Marker({
      position: { lat: location.latitude, lng: location.longitude },
      map,
      title: 'New Name',
    });
  }
  render() {
    const {
      classes,
      history,
      location,
      dishesTags,
      eateriesTags,
      cuisinesTags,
      cities,
    } = this.props;
    const cuisines = cuisinesTags.map((cuisine, i) => cuisine.name);
    return (
      <div>
        {/* <a
          rel="noopener noreferrer"
          target="_blank"
          href={links.map(location.latitude, location.longitude)}
        > */}
        <div className={classes.insetDarkTop}>
          <Grid container>
            <Grid item xs={11} className={classes.gridAlign}>
              {cities.length > 0 ? (
                <div className={classes.loaction}>
                  <i>{cities.length === 1 ? 'City' : 'Cities'} </i>
                  <CityTag history={history} items={cities} />
                </div>
              ) : (
                ''
              )}
            </Grid>
            <Grid item xs={11} className={classes.gridAlign}>
              <div className={classes.loaction}>
                <i>{location.locality.length > 0 ? 'Locality' : ''}</i>
                <div>{location.locality}</div>
              </div>
            </Grid>
          </Grid>
        </div>
        {/* <div style={{ height: '100px', width: '100%' }}>
            <GoogleMapReact
              defaultCenter={{
                lat: location.latitude,
                lng: location.longitude,
              }}
              bootstrapURLKeys={{ key: config.mapApiKey }}
              defaultZoom={14}
              onGoogleApiLoaded={({ map, maps }) =>
                this.renderMarkers(map, maps)
              }
              yesIWantToUseGoogleMapApiInternals
            />
          </div> */}
        {/* </a> */}
        <div className={classes.insetDarkBottom}>
          <Grid container>
            {dishesTags.length > 0 ? (
              <Grid item xs={12} className={classes.semibold}>
                <Typography variant="body2">DISHES</Typography>
                <div className={classes.tags}>
                  <TagNames history={history} items={dishesTags} />
                </div>
              </Grid>
            ) : (
              ''
            )}
            {eateriesTags.length > 0 ? (
              <Grid item xs={12} className={classes.semibold}>
                <Typography variant="body2">EATERIES</Typography>
                <TagNames history={history} items={eateriesTags} />
              </Grid>
            ) : (
              ''
            )}
            {cuisines.length > 0 ? (
              <Grid item xs={12} className={classes.semibold}>
                <Typography variant="body2">CUISINES</Typography>
                <div className={classes.tags}>
                  <TagNames history={history} items={cuisines} />
                </div>
              </Grid>
            ) : (
              ''
            )}
          </Grid>
        </div>
      </div>
    );
  }
}

SecondaryStory.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SecondaryStory);
